import { Component, Input } from '@angular/core';
import { DurationPipe } from '../../pipes/duration';
import { IDispatchStop } from '../../public/dispatch-tracking/dispatch-tracking.service';
import { formatDurationTime } from '../../public/dispatch-tracking/utils';
import { DispatchSummaryReportLabels } from '../../lib/i18n-backend-strings';

type IDispatchType = string;
@Component({
  selector: 'dispatch-step',
  styleUrls: ['./dispatch-step.component.scss'],
  templateUrl: './dispatch-step.component.html',
})
export class DispatchStepComponent {
  @Input() public dispatchStop: IDispatchStop;
  @Input() public showDateTimeStats: boolean;

  constructor(private durationPipe: DurationPipe) { }

  public get lateArrivalTime(): string {
    const showSeconds = false;
    const showDays = true;
    const roundOff = false;
    const useShortHandUnit = true;
    const postFixString = DispatchSummaryReportLabels.lateLabel;
    const duration: string = this.durationPipe.transform(
      Number(this.dispatchStop.lateArrivalTime),
      showSeconds,
      showDays,
      false,
      false,
      roundOff,
      useShortHandUnit,
      postFixString,
      true,
      false,
      true,
      'mins',
    );
    return formatDurationTime(duration);
  }

  public getUnknownLocationLabel(): string {
    const locationCity: string = this.dispatchStop.dispatchLocation.city;
    const locationState: string = this.dispatchStop.dispatchLocation.state;
    if (locationCity && locationState) return `${locationCity}, ${locationState}`;
    else return `${this.dispatchStop.dispatchLocation.lat}, ${this.dispatchStop.dispatchLocation.lon}`;
  }

  public getDispatchType(stopType: IDispatchStop['stopType']): IDispatchType {
    if (this.dispatchStop.skipShipperConsigneeStops) return stopType;
    switch (stopType) {
    case 'pickup':
      return $localize`PICKUP`;
    case 'pickupOrDropoff':
      return $localize`PICKUP & DROPOFF`;
    case 'dropoff':
      return $localize`DROPOFF`;
    case 'lastKnownLocation':
      return $localize`LAST KNOWN LOCATION`;
    }
  }
}
